// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__I7jOv","paramInput":"JobSimulator_paramInput__3RmrO","input":"JobSimulator_input__AcdsX"};